// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChatbotMessages_wrapper__oB6d4"};